
import { computed, defineComponent, onMounted, ref } from "vue";
import AlertConfiguration from "@/helpers/pages/AlertConfiguration";
import AgCard from "@/components/ag-card/index.vue";
import { useStore } from "@/store";
import { AlertActionTypes } from "@/store/modules/alert/action-types";
import api from "@/store/axiosAgsc";
import Swal from "sweetalert2";
import { Roles } from "@/helpers/enums/Roles";
import AgLoading from "@/components/ag-loading/index.vue";
import Multiselect from "@vueform/multiselect";
import $ from "jquery";
import '@vueform/slider/themes/default.css';

export default defineComponent({
  name: "DeploymentHealthAlerts",
  components: { AgCard, AgLoading, Multiselect },
  setup() {
    let currCondId = ref("");
    let categoryList: any = ref([]);
    let loading = ref(true);

    const newAlertJson = ref({
      selectedAlert: "",
    });

    const store = useStore();
    const module = ref(AlertConfiguration);
    const currCompanyGuid = store.state.auth.company.companyGuid;

    const sliderMin = 0;
    let sliderMax = ref(20);
    let sliderValue = ref(1);
    let tooltipPosition = ref(((sliderValue.value - sliderMin) / (sliderMax.value - sliderMin)) * 100);
    let updateTooltipPosition = (DefaultValue: any) => {
      tooltipPosition.value = ((DefaultValue - sliderMin) / (sliderMax.value - sliderMin)) * 100;
    };

    const getList = function () {
      setTimeout(() => {
        store
          .dispatch(AlertActionTypes.GET_ALARM_CONDITIONS, "")
          .then(async (response: any) => {
            const resp: any = await store.dispatch(
              AlertActionTypes.GET_ALERTCONDITION_CATS,
              4
            );

            categoryList.value = resp.entityData;
            if (categoryList.value[0] && categoryList.value[0].id) {
              newAlertJson.value.selectedAlert = categoryList.value[0].id;
              setTimeout(() => {
                try {
                  $('#target option:first').trigger('click');
                } catch (error) {
                  console.log(error)
                }
              }, 200);
            }

            response.entityData.deploymentHealthAlarmConditions.map((item: any) => {
              let alarmCateogryLabel = categoryList.value.filter((cat: any) => {
                return cat.id == item.alarmCateogryGuid;
              })[0];

              if (alarmCateogryLabel && alarmCateogryLabel.title)
                alarmCateogryLabel = alarmCateogryLabel.title;

              item.alarmCateogryLabel = alarmCateogryLabel;
            });

            response.entityData.deploymentHealthAlarmConditions =
              response.entityData.deploymentHealthAlarmConditions.filter((item: any) => {
                return item.alarmCateogryLabel;
              });

            if (response.entityData.deploymentHealthAlarmConditions.length > 0) {
              const sliderCondition = response.entityData.deploymentHealthAlarmConditions[0].conditionJson;
              try {
                const parsedCondition = JSON.parse(sliderCondition);

                if (Array.isArray(parsedCondition)) {
                  const sliderItem = parsedCondition.find((condition: any) => condition.Field === "Slider");

                  if (sliderItem) {
                    sliderValue.value = sliderItem.DefaultValue;
                    sliderMax.value = sliderItem.MaxValue;
                    updateTooltipPosition(sliderValue.value);
                  }
                } else {
                  console.log(parsedCondition);
                }
              } catch (error) {
                console.log("JSON parse error: ", error);
              }
            }else{
              sliderValue.value = 1;
              sliderMax.value = 20;
              updateTooltipPosition(sliderValue.value);
            }

            setTimeout(() => {
              loading.value = false;
            }, 350);

            module.value.deploymentHealthAlerts.component.options.rows =
              response.entityData.deploymentHealthAlarmConditions;
            module.value.deploymentHealthAlerts.component.options.total =
              response.entityData.deploymentHealthAlarmConditions.length;
          });
      }, 100);
    };

    onMounted(() => {
      getList();
    });

    let isEditing = () => {
      let rows = module.value.deploymentHealthAlerts.component.options.rows;
      let check = false;
      rows.forEach((row: any) => {
        if (row && row.alarmCateogryGuid) {
          if (row.alarmCateogryGuid === newAlertJson.value.selectedAlert) {
            check = true;
          }
        }
      });
      return check;
    };

    let getRow = (sel: string) => {
      let res = null;
      let rows = module.value.deploymentHealthAlerts.component.options.rows;
      rows.forEach((row: any) => {
        if (row && row.alarmCateogryGuid) {
          if (row.alarmCateogryGuid.trim() === sel.trim()) {
            res = row;
          }
        }
      });
      return res;
    };

    let selectAlert = (evt: any) => {
      let curRow = getRow(evt.target.value);
      if (curRow != null) {
        currCondId.value = curRow!["id"];
      }

    };

    const deleteFunction = function (id: any) {
      Swal.fire({
        title: "Are You Sure?",
        icon: "warning",
        text: "You are about to delete the selected item!",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          store
            .dispatch(AlertActionTypes.REMOVE_CONDITION, id)
            .then((response: any) => {
              if (response.isSuccess) {
                getList();
              }
              if (Number(response.statusCode) != 200) {
                Swal.fire("Error", response.Errors, "error");
              } else {
                Swal.fire("Deleted!", "The Alert has been deleted.", "success");
              }
            })
            .catch((e: any) => {
              Swal.fire("Error", JSON.stringify(e.Message), "error");
            });
        }
      });
    };

    return {
      module,
      categoryList,
      currCompanyGuid,
      deleteFunction,
      getList,
      newAlertJson,
      loading,
      isEditing,
      selectAlert,
      getRow,
      currCondId,
      sliderMin,
      sliderMax,
      tooltipPosition,
      sliderValue,
      updateTooltipPosition
    };
  },
  data: () => ({
    emails: [] as string[],
    sendEmail: false,
    Roles: Roles,
    compKey: 0,
  }),
  mounted() {
    this.newAlertJson.selectedAlert = "";
    if (this.emails.length === 0) {
      const store = useStore();
      const userEmail = store.state.auth.user.filter(
        (item) => item.type === "preferred_username"
      )[0]?.value;
      if (userEmail) {
        this.emails.push(userEmail);
      }
    }
  },
  computed: {
    currentConditions: {
      get: function () {
        let condition: any = this.categoryList.filter((i: any) => {
          return i.id == this.newAlertJson.selectedAlert;
        })[0];

        if (!condition || typeof condition === "undefined") {
          condition = this.categoryList[0];
        }

        if (this.isEditing()) {
          let row = this.getRow(this.newAlertJson.selectedAlert);
          condition = row;
        }

        try {
          if (condition != "undefined") {
            return JSON.parse(condition.conditionJson.replaceAll(/\n/g, ""));
          }
          else {
            return false;
          }
        } catch (error) {
          return false;
        }
      },
      set: function (value: any) {
        // console.log(value)
      },
    },
    currentCompanyGuid() {
      const store = useStore();
      return store.state.auth.company.companyGuid;
    },
  },
  methods: {
    async handleTagCreate(option: any, select$: any) {
      if (!option) {
        Swal.fire("Error", "Email is required", "error");
        setTimeout(() => {
          this.emails.pop();
          ++this.compKey;
        }, 300);
        return false;
      }

      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!regex.test(option)) {
        Swal.fire("Error", "This field must be a valid email", "error");
        setTimeout(() => {
          this.emails.pop();
          ++this.compKey;
        }, 300);
        return false;
      }

      return option;
    },
    addOrUpdateAlert(add = true) {
      if (this.emails.length === 0) {
        Swal.fire("Error", "Email is required and must be valid", "error");
        return;
      }
      let body = {
        alarmCateogryGuid: this.newAlertJson.selectedAlert,
        conditionJson: JSON.stringify(this.currentConditions),
        companyGuid: this.currentCompanyGuid,
        emails: this.emails,
        alarmType: 4,
        sendEmail: this.sendEmail,
        id: "",
      };
      if (!add) {
        body.id = this.currCondId;
      }

      //alert(JSON.stringify(body))
      let url = "";
      if (add) {
        url = "Alarm/CreateAlarmCondition";
      } else {
        url = "Alarm/UpdateCondition";
      }
      api.post(url, body).then((res) => {
        if (res && res.data.statusCode == 409) {
          Swal.fire({
            title: "Error",
            text: res.data.message,
            icon: "error",
            showCancelButton: false,
          });
        } else {
          this.getList();
        }
        this.newAlertJson.selectedAlert = "";
      });
    },
  },
});
